'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import useEmblaCarousel from 'embla-carousel-react';
import { useParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { buildGiftHeroImageUrl } from '@/app/_components/GiftCard/giftImage';
import { getGiftPreviewSnapshot, matchGiftPreview } from '@/app/_components/GiftCard/giftPreview';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ThumbnailBackedImage } from './ThumbnailBackedImage';
interface HeroImageProps {
  heroImageUrlList: string[];
  adultYN: boolean;
  thumbnailSrc?: string;
}
export const HeroImage = t0 => {
  const $ = _c(34);
  const {
    heroImageUrlList,
    adultYN,
    thumbnailSrc
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const params = useParams();
  let t1;
  if ($[0] !== params?.productNumber || $[1] !== thumbnailSrc) {
    t1 = () => thumbnailSrc ?? matchGiftPreview(getGiftPreviewSnapshot(), params?.productNumber)?.thumbnailSrc;
    $[0] = params?.productNumber;
    $[1] = thumbnailSrc;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [entryThumbnail] = useState(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      loop: true,
      align: "start"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t2);
  let t3;
  if ($[4] !== emblaApi) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    $[4] = emblaApi;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onSelect = t3;
  let t4;
  let t5;
  if ($[6] !== emblaApi || $[7] !== onSelect) {
    t4 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t5 = [emblaApi, onSelect];
    $[6] = emblaApi;
    $[7] = onSelect;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  const nextIndex = (selectedIndex + 1) % heroImageUrlList.length;
  let t6;
  if ($[10] !== adultYN || $[11] !== entryThumbnail || $[12] !== heroImageUrlList || $[13] !== isDesktopViewport || $[14] !== nextIndex || $[15] !== selectedIndex) {
    let t7;
    if ($[17] !== adultYN || $[18] !== entryThumbnail || $[19] !== isDesktopViewport || $[20] !== nextIndex || $[21] !== selectedIndex) {
      t7 = (url, index) => <div key={index} className="relative aspect-square min-w-0 flex-[0_0_100%] bg-Gray-black/10">{!isDesktopViewport || index === 0 ? <ThumbnailBackedImage src={buildGiftHeroImageUrl(url)} alt={`답례품 이미지 ${index + 1}`} thumbnailSrc={index === 0 ? entryThumbnail : undefined} loading={index === selectedIndex || index === nextIndex ? "eager" : "lazy"} preload={index === 0} fetchPriority={index === 0 ? "high" : undefined} /> : <Skeleton className="absolute size-full" />}{adultYN && <div className="absolute left-20 top-20 rounded-xsmall bg-B-500 px-12 py-4 font-600 text-Gray-white typo-body4">19세이상 구매가능</div>}</div>;
      $[17] = adultYN;
      $[18] = entryThumbnail;
      $[19] = isDesktopViewport;
      $[20] = nextIndex;
      $[21] = selectedIndex;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t6 = heroImageUrlList.map(t7);
    $[10] = adultYN;
    $[11] = entryThumbnail;
    $[12] = heroImageUrlList;
    $[13] = isDesktopViewport;
    $[14] = nextIndex;
    $[15] = selectedIndex;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[23] !== t6) {
    t7 = <div className="flex">{t6}</div>;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== emblaRef || $[26] !== t7) {
    t8 = <div className="overflow-hidden" ref={emblaRef}>{t7}</div>;
    $[25] = emblaRef;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== heroImageUrlList.length || $[29] !== selectedIndex) {
    t9 = heroImageUrlList.length > 1 && <div className="absolute inset-x-0 bottom-32 mx-auto w-fit rounded-pill bg-Gray-black/20 px-8 py-2 font-600 text-Gray-white typo-caption2">{selectedIndex + 1} / {heroImageUrlList.length}</div>;
    $[28] = heroImageUrlList.length;
    $[29] = selectedIndex;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t8 || $[32] !== t9) {
    t10 = <div className="relative w-full">{t8}{t9}</div>;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};